import { create } from 'apisauce';
import config from '../config';

const api = create({
  baseURL: config.baseURL,
});

const authApi = create({
  baseURL: config.authBaseURL,
});

export default {
  getLead: email => api.get(`/v1/leads/${email}`),
  saveLead: leadData => api.post('/v1/leads', leadData),
  saveLeadActivate: leadData => api.post('/v1/leads/activate', leadData),
  inactivateUser: email => api.patch(`/v1/leads/${email}/acceptTerms`),
  acceptTerms: email => api.patch(`/v1/leads/${email}/acceptTerms`),
  savePermissions: email => api.patch(`/v1/leads/${email}/setPermissions`),
  saveInstall: email => api.patch(`/v1/leads/${email}/install`),
  authorizeApp: code => authApi.post(`/v1/app/authorize?code=${code}`),
};
